var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-offline"},[(_vm.isOffline)?_c('el-tag',{attrs:{"effect":"dark","type":"warning"}},[_vm._v("\n    "+_vm._s(_vm.$t('OFFLINE.IS_OFFLINE.SHORT'))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }